module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921100834_T.8559dc36.jpg";